import React from 'react'

import { useHistory, useParams } from 'react-router-dom'
import { useDeleteRequest } from '../../hooks/request'
import { UTILITY_BILLS_DETAIL } from '../../urls'
import Button from '../../components/common/Button'
import { getMonths } from '../../utils/types'

export default function UtilityBillsItem({ item, index, expenseReport }) {
    const productRemove = useDeleteRequest({ url: UTILITY_BILLS_DETAIL.replace('{id}', item.id) })
    const { marketId } = useParams()

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            expenseReport.request()
        }
    }

    const history = useHistory()

    function format(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        })
            .format(value)
            .replace(/,/g, ' ')
    }

    return (
        <tr className=" is-size-6" key={item.id}>
            <td style={{ width: 50 }} className="is-size-6">
                {index + 1}
            </td>
            <td>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>{format(item?.electricity || 0)}</div>
                </div>
            </td>
            <td className="is-size-6">{format(item?.electricityIndex)}</td>
            <td>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>{format(item?.water || 0)}</div>
                </div>
            </td>
            <td className="is-size-6">{format(item.waterIndex)} Сум</td>

            <td>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>{format(item?.gas || 0)}</div>
                </div>
            </td>

            <td className="is-size-6">{format(item.gasIndex)}</td>

            <td>{item.garbage}</td>
            <td className="is-size-6">{getMonths(item.month)}</td>
            <td>
                <div style={{ display: 'flex' }} className="has-text-right">
                    <Button
                        onClick={() => history.push({
                            pathname: `/rent/${marketId}/utility-bills/update/${item.id}`,
                            state: { item },
                        })}
                        className="mr-2 button is-success is-outlined is-small"
                        icon="pencil-outline"
                    />
                    <Button onClick={onDelete} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>
    )
}
